import { NavbarVariantEnum } from 'src/types';
import styled, { css } from 'styled-components';
import { NAVBAR_TRANSITION } from '../Navbar/BaseNavbar.styles';

export const NotificationDrawerStyled = styled.div<{
  isOpen: boolean;
  navOpen: boolean;
  variant?: NavbarVariantEnum;
  atlasVariant?: boolean;
}>`
  position: ${(props) => (props.atlasVariant ? 'fixed' : 'absolute')};
  left: ${(props) =>
    props.atlasVariant
      ? 'var(--atlas-global-nav-content-left, 260px)'
      : props.navOpen
        ? '260px'
        : '64px'};
  right: auto;
  top: 0;
  height: 100vh;
  width: ${(props) => (props.isOpen ? '370px' : '0')};
  overflow-y: auto;
  overflow-x: hidden;
  transition:
    left ${NAVBAR_TRANSITION},
    width 0.3s;
  transition-delay: ${(props) => (props.isOpen ? '0s' : '0.2s')};
  transition-property: width, left;
  background-color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N0
      : props.theme.atlas.semantic.color.surface.default};
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  z-index: 2000;

  @media (max-width: ${(props) => props.theme.newBreakpoints.narrow}px) {
    left: ${(props) =>
      props.atlasVariant
        ? 'var(--atlas-global-nav-content-left, 260px)'
        : props.variant === NavbarVariantEnum.REPORTER ||
            props.variant === NavbarVariantEnum.PUBLIC
          ? '0'
          : props.navOpen
            ? '260px'
            : '64px'};
    ${(props) =>
      props.isOpen
        ? css`
            position: ${props.atlasVariant ? 'fixed' : 'absolute'};
            width: ${props.variant === NavbarVariantEnum.REPORTER ||
            props.variant === NavbarVariantEnum.PUBLIC
              ? '100%'
              : '370px'};
          `
        : css`
            width: 0;
            * {
              display: none;
            }
          `};
  }
`;
export const StyledPageCover = styled.div<{
  navOpen: boolean;
  isOpen: boolean;
  atlasVariant?: boolean;
}>`
  background-color: #000000;
  position: ${(props) => (props.atlasVariant ? 'fixed' : 'absolute')};
  width: ${(props) =>
    props.atlasVariant
      ? `calc(100vw - var(--atlas-global-nav-content-left, 260px))`
      : `calc(100vw - ${props.navOpen ? `260px` : `64px`})`};
  visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
  left: ${(props) =>
    props.atlasVariant
      ? 'var(--atlas-global-nav-content-left, 260px)'
      : props.navOpen
        ? '260px'
        : '64px'};
  opacity: ${(props) => (props.isOpen ? '0.7' : '0')};
  transition:
    left ${NAVBAR_TRANSITION},
    visibility 0.4s,
    opacity 0.4s;
  top: 0;
  z-index: 2000;
  height: 100vh;
`;
